import PlanInformation from './containers/PlanInformation';
import PaymentMethods from './containers/PaymentMethods';
import BillingHistory from './containers/BillingHistory';
import { selectProfile } from '../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../store/store';
import MotionWrapper from '../../../layouts/MotionWrapper';
import { useNavigate } from 'react-router-dom';
import { PAYMENT_TABS } from './constants';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { PaymentTab } from './types';
import {
    getProfileDataThunk,
    getPaymentMethodsThunk,
    getSubsciptionHistoryThunk,
} from '../../../store/workspace/thunks';

/** Billing screen: the running plan, the saved cards and the past invoices. */
export default function Payment() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [tab, setTab] = useState<PaymentTab>('Cards');

    /** Billing belongs to the owner of the account, members never get to see it. */
    useEffect(() => {
        if (profile?.userRole === 'member') {
            navigate('/workspace');
        }
    }, [profile, navigate]);

    useEffect(() => {
        dispatch(getProfileDataThunk());
        dispatch(getPaymentMethodsThunk({ action: 'get_payment_methods' }));
        dispatch(getSubsciptionHistoryThunk({ action: 'get_subscription_status' }));
    }, [dispatch]);

    return (
        <MotionWrapper className={styles.container}>
            <PlanInformation />

            <div className={styles.cards_and_history}>
                <div className={styles.tab}>
                    {PAYMENT_TABS.map(item => <div
                        key={item.id}
                        className={styles.tab_item}
                        data-is-active={tab === item.id}
                        onClick={() => setTab(item.id)}
                    >
                        <span>{item.title}</span>
                    </div>)}
                </div>

                {tab === 'Cards' ? <PaymentMethods /> : <BillingHistory />}
            </div>
        </MotionWrapper>
    );
};
